const EMOJI_CDN = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64';

const EMOJI_MAP: Record<string, string> = {
  '⚡': '26a1',
  '🔒': '1f512',
  '💬': '1f4ac',
  '💱': '1f4b1',
  '✓': '2714-fe0f',
  '📦': '1f4e6',
  '👥': '1f465',
  '🗑': '1f5d1-fe0f',
  '👁': '1f441-fe0f',
  '🎟': '1f39f-fe0f',
  '💵': '1f4b5',
  '🧪': '1f9ea',
  '⏳': '23f3',
  '⏰': '23f0',
  '✕': '274c',
  '👤': '1f464',
  '📧': '1f4e7',
  '📱': '1f4f1',
  '🛡': '1f6e1-fe0f',
  '📋': '1f4cb',
  '🎉': '1f389',
  '🚪': '1f6aa',
  '🔐': '1f510',
  '⚙': '2699-fe0f',
  '🏠': '1f3e0',
  '🔔': '1f514',
  '🪙': '1fa99',
  '🕐': '1f550',
  '✉': '2709-fe0f',
  '📞': '1f4de',
  '🆔': '1f194',
  '📊': '1f4ca',
  '💎': '1f48e',
};

interface AppleEmojiProps {
  emoji: string;
  size?: number;
}

export function AppleEmoji({ emoji, size = 20 }: AppleEmojiProps) {
  const code = EMOJI_MAP[emoji];
  if (!code) return <span>{emoji}</span>;
  return (
    <img
      src={`${EMOJI_CDN}/${code}.png`}
      alt={emoji}
      width={size}
      height={size}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    />
  );
}
